// @flow
import { Icon } from 'semantic-ui-react';
import React from 'react';

export const ShareIcon = ({ onClick, disabled }) => (
  <Icon
    color="grey"
    data-testid="share-icon"
    disabled={disabled}
    name="share alternate"
    onClick={onClick}
    style={{ cursor: 'pointer' }}
  />
);
